





























































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketForm from '@/components/tickets/tickets-form/TicketForm.vue';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import IncidentsDrawer from '@/modules/tickets/incidents/shared/components/IncidentDrawer.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import {
    linkManagement,
    processingAndManagedManagement,
} from '@/modules/tickets/shared/store/namespaces';
import { NetworkSecurityInternetIncidentData } from '@/modules/tickets/incidents/network-security-internet/domain/network-security-internet-incident-data';
import AttachmentZone from '@/modules/tickets/incidents/shared/components/AttachementZone.vue';
import ProcessingAndManagedManagementGeneralInformation from '@/modules/tickets/incidents/processing-and-managed-management/components/ProcessingAndManagedManagementGeneralInformation.vue';
import ProcessingAndManagedManagementTicketConfirmation from '@/modules/tickets/incidents/processing-and-managed-management/components/ProcessingAndManagedManagementTicketConfirmation.vue';
import { ProcessingAndManagedManagementActions } from '@/modules/tickets/incidents/processing-and-managed-management/store/processing-and-managed-management.actions';
import { ProcessingAndManagedManagementGetters } from '@/modules/tickets/incidents/processing-and-managed-management/store/processing-and-managed-management.getters';
import { Incident } from '@/modules/tickets/incidents/shared/domain/incident';

@Component({
    name: 'processing-and-managed-management',
    components: {
        ProcessingAndManagedManagementTicketConfirmation,
        ProcessingAndManagedManagementGeneralInformation,
        AttachmentZone,
        IncidentsDrawer,
        TicketForm,
    },
})
export default class NetworkSecurityInternetIncident extends Vue {
    private currentStep: number = 1;
    private isValid: boolean = true;
    private highestStepReached: number = 1;
    private isMounted = false;

    async sendIncidentTicket() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        const failed = await this.createTicket(this.formValues.generalInformation);
        if (failed) {
            failed.showError();
        } else {
            this.$router.push({
                name: 'tickets',
            });
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        this.changeTitle({
            route: ['Tickets'],
            title: 'Incidente de Procesamiento y Gestión Administrada',
        });
        const failed = await this.fetchView();
        if (failed) {
            failed.showError();
        }
        this.isMounted = true;
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;

    @processingAndManagedManagement.Action(ProcessingAndManagedManagementActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @processingAndManagedManagement.Getter(ProcessingAndManagedManagementGetters.GET_FORM_VALUES)
    formValues!: {
        generalInformation: NetworkSecurityInternetIncidentData;
        typings: Typing[];
    };

    @processingAndManagedManagement.Action(ProcessingAndManagedManagementActions.CREATE_TICKET)
    createTicket!: (data: NetworkSecurityInternetIncidentData) => Promise<RequestResponse>;

    @processingAndManagedManagement.Getter(ProcessingAndManagedManagementGetters.GET_OPEN_INCIDENTS)
    incidents!: Incident[];
}
